import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconArrowRight = createIcon({
  displayName: 'IconArrowRight',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M12.29 19.29L13.71 20.71L22.41 12L13.71 3.29L12.29 4.71L19.59 12L12.29 19.29ZM15.76 11L16.76 12L15.76 13H2V11H15.76Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
